import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form } from 'react-bootstrap';
import { collection, getDocs, updateDoc, doc } from 'firebase/firestore';
import { db } from '../../../firebase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';

const HorairesOuverture = () => {
    const [horaires, setHoraires] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedHoraire, setSelectedHoraire] = useState(null);
    const [newHoraire, setNewHoraire] = useState({});
    const [selectedSaison, setSelectedSaison] = useState('été');
    const [filterSaison, setFilterSaison] = useState('toutes');

    useEffect(() => {
        fetchHoraires();
    }, []);

    const fetchHoraires = async () => {
        const horairesCollection = collection(db, 'horaires');
        const horairesSnapshot = await getDocs(horairesCollection);
        const horairesList = horairesSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
        setHoraires(horairesList);
    };

    const handleEditClick = (horaire) => {
        setSelectedHoraire(horaire);
        setNewHoraire(horaire);
        setSelectedSaison('été');
        setShowModal(true);
    };

    const handleSave = async () => {
        const horaireRef = doc(db, 'horaires', selectedHoraire.id);
        await updateDoc(horaireRef, newHoraire);
        setShowModal(false);
        setSelectedHoraire(null);
        fetchHoraires();
    };

    const handleChange = (event, index, saison) => {
        const { name, value } = event.target;
        setNewHoraire(prevState => {
            const updatedSaisons = prevState.saisons[saison].map((horaire, i) => (
                i === index ? { ...horaire, [name]: value } : horaire
            ));
            return {
                ...prevState,
                saisons: {
                    ...prevState.saisons,
                    [saison]: updatedSaisons
                }
            };
        });
    };

    const handleAddTimeSlot = (saison) => {
        setNewHoraire(prevState => ({
            ...prevState,
            saisons: {
                ...prevState.saisons,
                [saison]: [...prevState.saisons[saison], { début: '', fin: '' }]
            }
        }));
    };

    const handleRemoveTimeSlot = (index, saison) => {
        setNewHoraire(prevState => {
            const updatedSaisons = prevState.saisons[saison].filter((_, i) => i !== index);
            return {
                ...prevState,
                saisons: {
                    ...prevState.saisons,
                    [saison]: updatedSaisons
                }
            };
        });
    };

    const filteredHoraires = horaires.filter(horaire => {
        if (filterSaison === 'toutes') return true;
        return horaire.saisons?.[filterSaison] && horaire.saisons[filterSaison].length > 0;
    });

    return (
        <div className="container">
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                        <h1 className="h3 mb-2 text-gray-800">Gestion des Horaires d'Ouverture</h1>
                        <br />
                        <div className="card shadow mb-4">
                            <div className="card-header py-3 d-flex justify-content-between align-items-center">
                                <h6 className="m-0 font-weight-bold title-2">Horaires d'Ouverture</h6>
                                <Form.Group controlId="filterSaison">
                                    <Form.Control as="select" value={filterSaison} onChange={(e) => setFilterSaison(e.target.value)}>
                                        <option value="toutes">Toutes les saisons</option>
                                        <option value="été">Été</option>
                                        <option value="hiver">Hiver</option>
                                    </Form.Control>
                                </Form.Group>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>Jour</th>
                                                <th>Saison</th>
                                                <th>Heures d'Ouverture</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredHoraires.map((horaire) => (
                                                Object.keys(horaire.saisons).map((saison) => (
                                                    (filterSaison === 'toutes' || filterSaison === saison) && (
                                                        <tr key={`${horaire.id}-${saison}`}>
                                                            <td>{horaire.jour}</td>
                                                            <td>{saison.charAt(0).toUpperCase() + saison.slice(1)}</td>
                                                            <td>
                                                                {horaire.saisons[saison].map((h, index) => (
                                                                    <div key={index}>
                                                                        {h.début} - {h.fin}
                                                                    </div>
                                                                ))}
                                                            </td>
                                                            <td>
                                                                <Button onClick={() => {
                                                                    handleEditClick(horaire);
                                                                    setSelectedSaison(saison);
                                                                    
                                                                }}><FontAwesomeIcon icon={faEdit} /></Button>
                                                            </td>
                                                        </tr>
                                                    )
                                                ))
                                            ))}
                                        </tbody>
                                    </Table>
                                    {selectedHoraire && (
                                        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                                            <Modal.Header closeButton>
                                                <Modal.Title>Modifier les Horaires</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <div className="container-fluid">
                                                    <h5>Saison: {selectedSaison.charAt(0).toUpperCase() + selectedSaison.slice(1)}</h5>
                                                    {newHoraire.saisons?.[selectedSaison]?.map((h, index) => (
                                                        <Form.Group key={index}>
                                                            <div className="row mb-3">
                                                                <div className="col-md-5">
                                                                    <Form.Label>Début:</Form.Label>
                                                                    <Form.Control
                                                                        type="time"
                                                                        name="début"
                                                                        value={h.début}
                                                                        onChange={(e) => handleChange(e, index, selectedSaison)}
                                                                    />
                                                                </div>
                                                                <div className="col-md-5">
                                                                    <Form.Label>Fin:</Form.Label>
                                                                    <Form.Control
                                                                        type="time"
                                                                        name="fin"
                                                                        value={h.fin}
                                                                        onChange={(e) => handleChange(e, index, selectedSaison)}
                                                                    />
                                                                </div>
                                                                <div className="col-md-2 d-flex align-items-end">
                                                                    <Button variant="danger" onClick={() => handleRemoveTimeSlot(index, selectedSaison)}>Supprimer</Button>
                                                                </div>
                                                            </div>
                                                        </Form.Group>
                                                    ))}
                                                    <Button variant="secondary" onClick={() => handleAddTimeSlot(selectedSaison)} className='btn-success'>Ajouter une plage horaire</Button>
                                                </div>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="secondary" onClick={() => setShowModal(false)}>Fermer</Button>
                                                <Button variant="primary" onClick={handleSave}>Sauvegarder</Button>
                                            </Modal.Footer>
                                        </Modal>
                                    )}
                                </div>
                            </div>
                        </div>
                  
                </div>
            </div>
        </div>
    );
};

export default HorairesOuverture;
